'use client'

import { ReactNode, useEffect, useRef, useState } from 'react'

import classNames from 'classnames'
import s from './style.module.css'

export const CONTENT_GROUP_CLASS_NAME = 'contentGroup'
const GLOWS = [
	{
		id: 'boundary',
		gradient:
			'122deg, rgba(146,47,48, 0.7) 42.11%, rgba(255,158,162, 0.7) 64.99%, rgba(226,67,41, 0.7) 88.52%',
	},
	{
		id: 'consul',
		gradient:
			'122deg, rgba(226,41,174, 0.5) 36.05%, rgba(255,143,190,0.5) 54.77%, rgba(255,76,151, 0.5) 88.52%',
	},
	{
		id: 'ilm',
		gradient:
			'72deg, rgba(128, 64, 201, 0.70) -9.6%, rgba(98, 126, 239, 0.70) 30.9%, rgba(72, 200, 255, 0.70) 71.43%, rgba(78, 242, 233, 0.70) 103.93%',
	},
	{
		id: 'nomad',
		gradient:
			'83deg, rgba(13, 255, 197, 0.70) 8.23%, rgba(25, 243, 173, 0.70) 41.96%, rgba(20, 198, 203, 0.70) 69.26%',
	},
	{
		id: 'packer',
		gradient:
			'77deg, rgba(98, 126, 239, 0.6) -31.17%, rgba(72, 200, 255, 0.6) 61.16%',
	},
	{
		id: 'slm',
		gradient:
			'77deg, rgba(244, 193, 94, 0.70) -31.17%, rgba(236, 88, 93, 0.70) 61.16%',
	},
	{
		id: 'terraform',
		gradient:
			'77deg, rgba(128, 64, 201, 0.70) 3.68%, rgba(98, 126, 239, 0.70) 74.13%',
	},
	{
		id: 'vault',
		gradient:
			'122deg, rgba(152,82,45, 0.7) 45.29%, rgba(255,233,177, 0.7) 64.01%, rgba(255,207,37,0.7) 80.76%',
	},
	{
		id: 'nomad-waypoint',
		gradient:
			'83deg, rgba(13, 255, 197, 0.50) 8.23%, rgba(25, 243, 173, 0.50) 41.96%, rgba(20, 198, 203, 0.50) 69.26%',
	},
]

const ScrollingGlow = ({ children }: { children: ReactNode }) => {
	const [currentGradient, setCurrentGradient] = useState<string>(null)
	const [maskIsVisible, setMaskIsVisible] = useState<boolean>(false)
	const contentGroupsRef = useRef<HTMLDivElement>()

	const callback = (entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				const id = entry.target.getAttribute('data-glow-id')
				setCurrentGradient(id ? id : null)
			}
		})
	}

	useEffect(() => {
		const observer = new IntersectionObserver(callback, {
			rootMargin: '-49% 0px -49% 0px',
			threshold: 0,
		})

		if (contentGroupsRef.current) {
			contentGroupsRef.current
				.querySelectorAll(`.${CONTENT_GROUP_CLASS_NAME}`)
				.forEach((i) => {
					if (i) {
						observer.observe(i)
					}
				})
		}
		return () => {
			if (contentGroupsRef.current) {
				contentGroupsRef.current
					.querySelectorAll(`.${CONTENT_GROUP_CLASS_NAME}`)
					.forEach((i) => {
						if (i) {
							observer.unobserve(i)
						}
					})
			}
		}
	}, [contentGroupsRef])

	useEffect(() => {
		if (currentGradient) {
			setMaskIsVisible(true)
		} else {
			setMaskIsVisible(false)
		}
	}, [currentGradient])

	return (
		<div className={classNames([s.root, 'mds-dark-mode'])}>
			<div className={classNames([s.mask, { [s.isActive]: maskIsVisible }])} />
			<div className={s.glowWrapper}>
				{GLOWS.map((glow, id) => {
					return (
						<div
							key={`${id}-${glow.id}`}
							className={classNames([
								s.glow,
								{ [s.isActive]: currentGradient === glow.id },
							])}
							style={{
								background: `linear-gradient(${glow.gradient})`,
							}}
						/>
					)
				})}
			</div>

			<div ref={contentGroupsRef}>{children}</div>
		</div>
	)
}

export default ScrollingGlow
